<template>
  <h1>Boosts Rewards Component</h1>
</template>

<script lang="ts" setup></script>
